import styled from 'styled-components'

export const Main = styled.main`
  padding: 100px 20px 0px 20px;
  height: 100%;
  width: 100%;
  > div {
    display: flex;
    flex-direction: column;
    margin: 0px auto;
    max-width: 860px;
    > span {
      ${({ theme }) => theme.wev_font.Regular_16};
      margin-top: 30px;
      text-align: right;
      color: ${({ theme }) => theme.wev_color.primary};
    }
  }
  @media ${({ theme }) => theme.device.pc} {
    padding-top: 50px;
  }
`

export const Title = styled.h1`
  text-align: center;
  ${({ theme }) => theme.wev_font.Bold_36};
`
export const Desc = styled.p`
  text-align: center;
  margin-top: 20px;
  ${({ theme }) => theme.wev_font.Regular_20};
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 50px;
  > div {
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 20px;
    @media ${({ theme }) => theme.device.mobile} {
      flex-direction: column;
    }
  }
`
